/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { SetYardBlockGeometryCommand } from '../model';
// @ts-ignore
import type { YardBlockDto } from '../model';
/**
 * YardBlockGeometriesApi - axios parameter creator
 */
export const YardBlockGeometriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SetYardBlockGeometryCommand} [setYardBlockGeometryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockGeometriesSet: async (setYardBlockGeometryCommand?: SetYardBlockGeometryCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/YardBlockGeometries/Set`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setYardBlockGeometryCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * YardBlockGeometriesApi - functional programming interface
 */
export const YardBlockGeometriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = YardBlockGeometriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {SetYardBlockGeometryCommand} [setYardBlockGeometryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yardBlockGeometriesSet(setYardBlockGeometryCommand?: SetYardBlockGeometryCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YardBlockDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yardBlockGeometriesSet(setYardBlockGeometryCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YardBlockGeometriesApi.yardBlockGeometriesSet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * YardBlockGeometriesApi - factory interface
 */
export const YardBlockGeometriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = YardBlockGeometriesApiFp(configuration)
    return {
        /**
         * 
         * @param {YardBlockGeometriesApiYardBlockGeometriesSetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yardBlockGeometriesSet(requestParameters: YardBlockGeometriesApiYardBlockGeometriesSetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<YardBlockDto> {
            return localVarFp.yardBlockGeometriesSet(requestParameters.setYardBlockGeometryCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for yardBlockGeometriesSet operation in YardBlockGeometriesApi.
 */
export interface YardBlockGeometriesApiYardBlockGeometriesSetRequest {
    readonly setYardBlockGeometryCommand?: SetYardBlockGeometryCommand
}

/**
 * YardBlockGeometriesApi - object-oriented interface
 */
export class YardBlockGeometriesApi extends BaseAPI {
    /**
     * 
     * @param {YardBlockGeometriesApiYardBlockGeometriesSetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public yardBlockGeometriesSet(requestParameters: YardBlockGeometriesApiYardBlockGeometriesSetRequest = {}, options?: RawAxiosRequestConfig) {
        return YardBlockGeometriesApiFp(this.configuration).yardBlockGeometriesSet(requestParameters.setYardBlockGeometryCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

